import ReactDOM from 'react-dom/client';
import store from './store';
import { Provider } from 'react-redux';
import {
  GlobalSharedStyles,
  GlobalRedboxAppStyles,
} from './styles/globalStyles';
import QuestionsFormPage from './components/QuestionsFormPage';
import useBackendPath from './hooks/useBackendPath';

const container = document.getElementById('root-assessment-tool');

if (!container) {
  throw new Error('No root found in the DOM');
}

const root = ReactDOM.createRoot(container);

root.render(
  (() => {
    const { backendPath } = useBackendPath();

    return (
      <Provider store={store}>
        <GlobalRedboxAppStyles />
        <GlobalSharedStyles backendPath={backendPath} />
        <QuestionsFormPage />
      </Provider>
    );
  })(),
);
